import type { Dispatch, SetStateAction } from 'react';

import isEqual from 'date-fns/isEqual';
import { useEffect, useState } from 'react';

// Main purpose of this hook it to have a state that can be updated from the parent
const useInputState = <T>(value: T): [T, Dispatch<SetStateAction<T>>] => {
  const [newValue, setNewValue] = useState<T>(value);
  // console.log('rerendered state', newValue)

  useEffect(() => {
    switch (typeof value) {
      case 'number':
      case 'string': {
        if (newValue !== value) {
          setNewValue(value);
        }
        break;
      }
      case 'object': {
        if (!value) {
          setNewValue(value);
          break;
        }
        if (
          newValue instanceof Date &&
          value instanceof Date &&
          !isEqual(newValue, value)
        ) {
          setNewValue(value);
        }
        break;
      }
      case 'undefined': {
        if (!newValue) {
          setNewValue(value);
        }
        break;
      }
      default: {
        throw new Error('Not supported type of state');
      }
    }
    // eslint-disable-next-line
  }, [value])

  return [newValue, setNewValue];
};

export default useInputState;
